import { h } from "omi";

import { IconProps } from "@/components";

export function DotsVerticalIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 20 20">
      <path
        d="M9.99984 10.8335c.46026 0 .83336-.3731.83336-.8333 0-.46027-.3731-.83337-.83336-.83337-.46024 0-.83334.3731-.83334.83337 0 .4602.3731.8333.83334.8333ZM9.99984 5.00016c.46026 0 .83336-.37309.83336-.83333 0-.46024-.3731-.83333-.83336-.83333-.46024 0-.83334.37309-.83334.83333 0 .46024.3731.83333.83334.83333ZM9.99984 16.6668c.46026 0 .83336-.3731.83336-.8333 0-.4602-.3731-.8333-.83336-.8333-.46024 0-.83334.3731-.83334.8333 0 .4602.3731.8333.83334.8333Z"
        stroke="#fff"
        fill="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
